import { Color } from "./color";

export interface Intent {
  backgroundColor: Color;
  iconColor: Color;
  textColor: Color;
}

const createIntent = (backgroundColor: Color, iconColor: Color, textColor: Color): Intent => {
  return {
    backgroundColor,
    iconColor,
    textColor,
  };
}

export const Intent = {
  ERROR: createIntent(Color.ERROR_BACKGROUND, Color.ERROR_ICON, Color.ERROR_TEXT),
  INFO: createIntent(Color.INFO_BACKGROUND, Color.INFO_ICON, Color.INFO_TEXT),
  SUCCESS: createIntent(Color.SUCCESS_BACKGROUND, Color.SUCCESS_ICON, Color.SUCCESS_TEXT),
  WARNING: createIntent(Color.WARNING_BACKGROUND, Color.WARNING_ICON, Color.WARNING_TEXT),
};
